import { isNil } from 'lodash-es';
import { numberToPercentage } from '../../../utils/formatter';

export const formatValue = (value) => {
  if (isNil(value)) return '—';
  if (value === 0) return '0%';
  return numberToPercentage(value, { precision: 1 });
};
